// extracted by mini-css-extract-plugin
module.exports = {"signInButton":"UserItem__signInButton--overlay--38Qjt"};
    if(module.hot) {
      // 1605595234975
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  